import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  state: false,
  page: "",
  modal: "",
  sideBar: "",
  sideBarSwitch: false,
  data: "",
  id: "",
};

const modal = createSlice({
  name: "modal",
  initialState: initialState,
  reducers: {
    switchModal(store, action) {
      const { state, modal, data } = action.payload;
      store.state = state;
      store.modal = modal;
      store.data = data;
    },
    switchPage(store, action) {
      const { page } = action.payload;
      store.page = page;
      store.state = false;
    },
    closeModal(store, action) {
      store.state = false;
    },
    switchSideBar(store, action) {
      const { sideBar } = action.payload;
      store.sideBar = sideBar;
    },
    closeSideBar(store, action) {
      const { sideBarSwitch } = action.payload;
      store.sideBarSwitch = sideBarSwitch;
    },
    addData(store, action) {
      const { state, data, key, id } = action.payload;
      store.state = state;
      store.data = data;
      store.key = key;
      store.id = id;
    },
  },
});

export const {
  switchModal,
  switchPage,
  closeModal,
  switchSideBar,
  closeSideBar,
  addData,
} = modal.actions;

export default modal.reducer;
